export const formatCurrency = (amount, currency = "MMK") => {
  const options = {};

  if (currency === "USD") {
    options.minimumFractionDigits = 2;
    options.maximumFractionDigits = 2;
  }

  return (
    new Intl.NumberFormat("en-US", options).format(amount || 0) + " " + currency
  );
};

export const formatNum = (num) => {
  return new Intl.NumberFormat("en-US").format(num || 0);
};
